import { css } from "@agapi/ui/panda/css";

export const styledMarkdown = css.raw({
  display: "flex",
  flexDir: "column",
  flexWrap: "wrap",
  fontSize: "md",
  gap: "tight",
  "& h1": {
    textStyle: "h1",
  },
  "& h2": {
    textStyle: "h2",
  },
  "& h3": {
    textStyle: "h3",
    fontSize: "2xl",
    fontWeight: "semibold",
    lineHeight: "tight",
  },
  "& p": {
    textStyle: "body",
  },
  "& a": {
    fontWeight: "medium",
    textDecoration: "underline!",
    opacity: 0.9
  },
  "& em": {
    fontStyle: 'italic',
  },
  "& strong": {
    fontWeight: "bold",
  },
  "& ul": {
    listStyleType: 'disc',
    pl: 'snug',
  },
  "& li": {
    textStyle: 'body',
    pb: "2",
  },
  '& table': {
    borderRadius: '3',
    overflow: 'hidden',
    boxShadow: '0 0 0 1px token(colors.surface.primary.subdued.border)',
  },
  '& th': {
    backgroundColor: 'surface.primary.vibrant.background',
    color: 'surface.primary.vibrant.foreground',
    textAlign: 'left',
    padding: '3',
  },
  '& td': {
    textAlign: 'left',
    padding: '3',
    borderLeft: '1px solid',
    borderColor: 'surface.primary.subdued.border',
    _first: {
      fontWeight: 'bold',
      borderLeft: 'none',
    },
  },
  '& tr:nth-child(even)': {
    backgroundColor: 'surface.primary.subdued.background',
  },
});

export const styledMarkdownOverride = css.raw({
  '& h2': {
    textStyle: 'h3'
  },
  '& h3': {
    textStyle: 'h4'
  },
  '& h4': {
    textStyle: 'h5'
  },
  '& h5': {
    textStyle: 'h6'
  },
});
